import { render, staticRenderFns } from "./RedXSolidIcon.vue?vue&type=template&id=5c54efa8&"
import script from "./RedXSolidIcon.vue?vue&type=script&lang=js&"
export * from "./RedXSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports